import React, { useEffect, useState } from 'react'
import { systemCode, xs_languageCode, xs_sessionToken } from '../../..';
import { getConfiguration } from '../../utils';
import axios from 'axios';

function ToggleNotifications({ state, dispatch }) {
    const conf = getConfiguration();
    const whitelistedSport = Object.keys(conf.pnc?.whitelistedSport || {});
    const [autoNotificationEventsScore, setAutoNotificationEventsScore] = useState(state?.data?.notificationEventsEnabled);
    const [autoNotificationWinningTicket, setAutoNotificationWinningTicket] = useState(state?.data?.notificationWinningEnabled);
    const [showAutoNotificationToggler,setShowAutoNotificationToggler] = useState(whitelistedSport?.length == 0 || true);

    useEffect(() => {
        if (state?.data) {
            setAutoNotificationEventsScore(state.data.notificationEventsEnabled);
            setAutoNotificationWinningTicket(state.data.notificationWinningEnabled);
        }

        whitelistedSport.length > 0 && state?.data?.events?.forEach(e=> {
        if(!whitelistedSport?.includes(''+e.sportRef))  {
            setShowAutoNotificationToggler(false);
        }
    })
    }, [state?.data]);

    

    const changePushNotificationSettings = async (newEventScore, newWinningTicket) => {
        const url = conf.api['changePushNotificationSettings'];
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            token: xs_sessionToken,
            ticketId: state.data.id,
            autoNotificationEventsScore: newEventScore,
            autoNotificationWinningTicket: newWinningTicket
        };

        try {
            const response = await axios.post(url, null, { params });

            if (!response?.data) {
                console.warn('No response');
            } else {
                dispatch({
                    type: 'FETCH_SUCCESS',
                    payload: {
                        ...state.data,
                        notificationEventsEnabled: newEventScore,
                        notificationWinningEnabled: newWinningTicket,
                    }
                });
            }
        } catch (e) {
            console.error('Error: ', e);
        }
    };

    const handleToggleWinning = (e) => {
        const newValue = e.target.checked;
        setAutoNotificationWinningTicket(newValue);
        changePushNotificationSettings(autoNotificationEventsScore, newValue);
    };

    const handleToggleEvents = (e) => {
        const newValue = e.target.checked;
        setAutoNotificationEventsScore(newValue);
        changePushNotificationSettings(newValue, autoNotificationWinningTicket);
    };

    return (showAutoNotificationToggler &&
        <div className='notification__wrapper'>
            <div className='notification__item'>
                <label className="custom-switch-2">
                    <input id="notifications__winning"
                        type="checkbox"
                        checked={autoNotificationWinningTicket}
                        onChange={handleToggleWinning}
                    ></input>
                    <span className="custom-slider-2 round"></span>
                </label>
                <span className="ml-2">{`Notifiche vincita (Android App)`}</span>
            </div>
            <div className='notification__item'>
                <label className="custom-switch-2">
                    <input id="notifications__events"
                        type="checkbox"
                        checked={autoNotificationEventsScore}
                        onChange={handleToggleEvents}
                    ></input>
                    <span className="custom-slider-2 round"></span>
                </label>
                <span className="ml-2">{`Notifiche info evento (Android App)`}</span>
            </div>
        </div>
    )
}

export default ToggleNotifications